import { render, staticRenderFns } from "./StudyRecord.vue?vue&type=template&id=445d89ad&scoped=true"
import script from "./StudyRecord.vue?vue&type=script&lang=js"
export * from "./StudyRecord.vue?vue&type=script&lang=js"
import style0 from "./StudyRecord.vue?vue&type=style&index=0&id=445d89ad&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445d89ad",
  null
  
)

export default component.exports